// Bilingual content for the home feature-strip modals.
export const FEATURE_INFO = {
  strip_secure: {
    fr: {
      title: "Sécurisé",
      subtitle: "Vos transactions en toute sécurité",
      desc: "Sur agoomarket, chaque transaction est protégée de bout en bout. Nous vérifions les vendeurs et sécurisons vos paiements pour que vous achetiez en toute confiance.",
      how: [
        "Les vendeurs sont vérifiés avant de pouvoir publier leurs produits.",
        "Votre paiement et votre commande sont suivis à chaque étape.",
        "Vous pouvez payer à la livraison et ne validez qu'une fois le colis reçu.",
      ],
      functions: [
        "Vendeurs vérifiés et notés par la communauté",
        "Suivi de commande avec historique des statuts",
        "Paiement en espèces à la livraison disponible",
        "Assistance en cas de litige",
      ],
    },
    en: {
      title: "Secure",
      subtitle: "Your transactions fully protected",
      desc: "On agoomarket, every transaction is protected end to end. We verify sellers and secure your payments so you can shop with confidence.",
      how: [
        "Sellers are verified before they can list products.",
        "Your payment and order are tracked at every step.",
        "You can pay on delivery and only confirm once the parcel is received.",
      ],
      functions: [
        "Verified sellers rated by the community",
        "Order tracking with full status history",
        "Cash on delivery available",
        "Support in case of a dispute",
      ],
    },
  },
  strip_pay: {
    fr: {
      title: "Paiements faciles",
      subtitle: "Mobile Money et cartes bancaires",
      desc: "Payez comme vous voulez : Mobile Money (Flooz, T-Money) ou en espèces à la livraison. Simple, rapide et adapté au Togo.",
      how: [
        "Ajoutez vos produits au panier et passez au paiement.",
        "Choisissez Mobile Money ou le paiement à la livraison.",
        "Recevez une confirmation immédiate de votre commande.",
      ],
      functions: [
        "Mobile Money : Flooz & T-Money",
        "Paiement en espèces à la réception",
        "Confirmation instantanée de la commande",
        "Récapitulatif clair : sous-total, livraison, total",
      ],
    },
    en: {
      title: "Easy payments",
      subtitle: "Mobile Money and bank cards",
      desc: "Pay the way you want: Mobile Money (Flooz, T-Money) or cash on delivery. Simple, fast and tailored to Togo.",
      how: [
        "Add products to your cart and go to checkout.",
        "Choose Mobile Money or cash on delivery.",
        "Get an instant confirmation of your order.",
      ],
      functions: [
        "Mobile Money: Flooz & T-Money",
        "Cash on delivery",
        "Instant order confirmation",
        "Clear summary: subtotal, delivery, total",
      ],
    },
  },
  strip_delivery: {
    fr: {
      title: "Livraison rapide",
      subtitle: "À domicile partout au Togo",
      desc: "Vos commandes sont livrées rapidement partout au Togo par nos livreurs, avec un suivi en temps réel sur la carte.",
      how: [
        "Un livreur accepte votre commande dès qu'elle est prête.",
        "Suivez sa position en temps réel sur la carte.",
        "Recevez votre colis à l'adresse indiquée en 24 à 72h.",
      ],
      functions: [
        "Suivi GPS du livreur en temps réel",
        "Livraison standard ou express",
        "Notifications e-mail à chaque étape",
        "Livraison partout au Togo",
      ],
    },
    en: {
      title: "Fast delivery",
      subtitle: "To your door across Togo",
      desc: "Your orders are delivered quickly across Togo by our couriers, with real-time tracking on the map.",
      how: [
        "A courier accepts your order as soon as it is ready.",
        "Follow their position in real time on the map.",
        "Receive your parcel at your address within 24 to 72h.",
      ],
      functions: [
        "Real-time GPS courier tracking",
        "Standard or express delivery",
        "Email notifications at every step",
        "Delivery everywhere in Togo",
      ],
    },
  },
  strip_all: {
    fr: {
      title: "Pour tous",
      subtitle: "Acheteurs et vendeurs",
      desc: "agoomarket est ouvert à tous : achetez, vendez ou livrez. Chacun trouve sa place et grandit avec nous.",
      how: [
        "Créez un compte gratuit en quelques secondes.",
        "Choisissez votre rôle : acheteur, vendeur ou livreur.",
        "Commencez à acheter, publier vos produits ou livrer.",
      ],
      functions: [
        "Espace acheteur : panier, favoris, commandes",
        "Espace vendeur : boutique, produits, statistiques",
        "Espace livreur : commandes à livrer et suivi",
        "Inscription gratuite et rapide",
      ],
    },
    en: {
      title: "For everyone",
      subtitle: "Buyers and sellers",
      desc: "agoomarket is open to everyone: buy, sell or deliver. Everyone has a place and grows with us.",
      how: [
        "Create a free account in a few seconds.",
        "Pick your role: buyer, seller or courier.",
        "Start buying, listing your products or delivering.",
      ],
      functions: [
        "Buyer space: cart, wishlist, orders",
        "Seller space: shop, products, statistics",
        "Courier space: deliveries and tracking",
        "Free and fast sign-up",
      ],
    },
  },
  strip_support: {
    fr: {
      title: "Support 7J/7",
      subtitle: "Nous sommes là pour vous",
      desc: "Une question ? Notre assistant IA et notre équipe locale sont disponibles 7j/7 pour vous accompagner.",
      how: [
        "Ouvrez l'assistant en bas à droite de l'écran.",
        "Posez votre question à tout moment, jour et nuit.",
        "Notre équipe locale prend le relais si nécessaire.",
      ],
      functions: [
        "Assistant IA intégré, disponible 7j/7",
        "Équipe locale basée à Lomé",
        "Aide sur les commandes et les livraisons",
        "Réponses en français et en anglais",
      ],
    },
    en: {
      title: "7/7 support",
      subtitle: "We're always here for you",
      desc: "A question? Our AI assistant and local team are available 7 days a week to help you.",
      how: [
        "Open the assistant at the bottom right of the screen.",
        "Ask your question anytime, day or night.",
        "Our local team steps in when needed.",
      ],
      functions: [
        "Built-in AI assistant, available 7/7",
        "Local team based in Lomé",
        "Help with orders and deliveries",
        "Answers in French and English",
      ],
    },
  },
  buy: {
    fr: {
      title: "Achetez", subtitle: "Commandez en quelques clics",
      desc: "Parcourez des milliers de produits du grand marché de Lomé et commandez en toute simplicité, livrés chez vous.",
      how: ["Recherchez ou filtrez les produits par catégorie.", "Ajoutez au panier et validez votre commande.", "Payez par Mobile Money ou à la livraison."],
      functions: ["Catalogue complet avec recherche et filtres", "Panier et liste de favoris", "Suivi de commande en temps réel", "Avis clients pour bien choisir"],
    },
    en: {
      title: "Buy", subtitle: "Order in a few clicks",
      desc: "Browse thousands of products from the great market of Lomé and order easily, delivered to your door.",
      how: ["Search or filter products by category.", "Add to cart and place your order.", "Pay by Mobile Money or on delivery."],
      functions: ["Full catalog with search and filters", "Cart and wishlist", "Real-time order tracking", "Customer reviews to choose well"],
    },
  },
  sell: {
    fr: {
      title: "Vendez", subtitle: "Ouvrez votre boutique",
      desc: "Créez votre boutique en ligne, publiez vos produits et vendez à tout le Togo depuis agoomarket.",
      how: ["Créez un compte vendeur gratuit.", "Personnalisez votre boutique (logo, couverture).", "Publiez vos produits et recevez des commandes."],
      functions: ["Boutique personnalisée", "Gestion des produits et du stock", "Tableau de bord ventes et revenus", "Notifications de nouvelles commandes par e-mail"],
    },
    en: {
      title: "Sell", subtitle: "Open your shop",
      desc: "Create your online shop, list your products and sell across Togo on agoomarket.",
      how: ["Create a free seller account.", "Customize your shop (logo, cover).", "List your products and receive orders."],
      functions: ["Custom storefront", "Product and stock management", "Sales and revenue dashboard", "New-order email notifications"],
    },
  },
  grow: {
    fr: {
      title: "Grandissons ensemble", subtitle: "Une communauté qui avance",
      desc: "agoomarket met en relation acheteurs, vendeurs et livreurs pour faire grandir le commerce local togolais.",
      how: ["Vendeurs et livreurs rejoignent la plateforme.", "Les clients soutiennent les commerçants locaux.", "Chacun développe son activité et sa visibilité."],
      functions: ["Mise en avant des boutiques locales", "Rôle livreur pour gagner des revenus", "Avis et notes communautaires", "Support local basé à Lomé"],
    },
    en: {
      title: "Let's grow together", subtitle: "A community moving forward",
      desc: "agoomarket connects buyers, sellers and couriers to grow local Togolese commerce.",
      how: ["Sellers and couriers join the platform.", "Customers support local merchants.", "Everyone grows their business and visibility."],
      functions: ["Local storefronts showcased", "Courier role to earn income", "Community reviews and ratings", "Local support based in Lomé"],
    },
  },
};
